import { AuthPage } from '../../../src/components/pages/auth';

export const Register = () => {
  return <AuthPage type='register' />;
};
